export const ISRESULT = 'ISRESULT';

//MenuRole
export const GET_DATA_PERMISSION = 'GET_DATA_PERMISSION';
export const GET_DATA_PERMISSION_SUCCEEDED = 'GET_DATA_PERMISSION_SUCCEEDED';
export const REQUERT_DATA_PERMISSION_FAILED = 'REQUERT_DATA_PERMISSION_FAILED';

//UserMenu
export const GET_DATA_USER_MENU = 'GET_DATA_USER_MENU';
export const GET_DATA_USER_MENU_SUCCEEDED = 'GET_DATA_USER_MENU_SUCCEEDED';
export const DELETE_DATA_USER_MENU = "DELETE_DATA_USER_MENU";
export const REQUERT_USER_MENU_FAILED = 'GET_DATA_USER_MENU_FAILED';
export const SET_DATA_USER_MENU = 'SET_DATA_USER_MENU';

